import { Link } from "react-router-dom";
import { CATEGORY_META, FILMS } from "@/mocks/films";

export default function CategoryEntry() {
  const counts = CATEGORY_META.map(
    (cat) => FILMS.filter((film) => film.categories.includes(cat.slug)).length,
  );

  return (
    <section className="w-full bg-background-100 border-y border-background-200">
      <div className="w-full px-4 md:px-8 py-10 md:py-14">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3 mb-7">
            <div>
              <p className="text-[11px] tracking-[0.3em] uppercase text-accent-700 mb-1.5">
                Browse by Genre
              </p>
              <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-950">
                分类快捷入口
              </h2>
            </div>
            <p className="text-[13px] text-foreground-500 max-w-md">
              按题材快速进入对应资源列表，每一类都配有地区、年份与演员标签的组合筛选。
            </p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
            {CATEGORY_META.map((cat, index) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group relative flex flex-col items-start gap-3 p-4 rounded-lg bg-background-50 border border-background-200 hover:border-accent-400 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
              >
                <span className="w-10 h-10 rounded-md bg-primary-900 text-accent-400 flex items-center justify-center text-lg transition-colors group-hover:bg-accent-500 group-hover:text-primary-950">
                  <i className={cat.icon} />
                </span>
                <div>
                  <h3 className="font-heading text-[15px] font-semibold text-foreground-950">
                    {cat.name}
                  </h3>
                  <p className="mt-0.5 text-[11px] text-foreground-400">
                    {counts[index]} 部影片
                  </p>
                </div>
                <i className="ri-arrow-right-up-line absolute top-4 right-4 text-foreground-300 group-hover:text-accent-600 transition-colors" />
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}